import { BasketDiscountWriteCampaignProps } from 'apis/restaurant-api/merchant-admin/campaigns/api';
import { BasketDiscountType } from 'apis/restaurant-api/merchant-admin/campaigns/types';

export const getBasketDiscountValue = (
  discountType: BasketDiscountType,
  discountValue: BasketDiscountWriteCampaignProps['basketDiscount'],
): BasketDiscountWriteCampaignProps['basketDiscount'] =>
  discountType === BasketDiscountType.PERCENTAGE
    ? {
        [BasketDiscountType.AMOUNT]: null,
        [BasketDiscountType.PERCENTAGE]: discountValue.percentage,
        upperLimit: discountValue.upperLimit,
      }
    : {
        [BasketDiscountType.AMOUNT]: discountValue.amount,
        [BasketDiscountType.PERCENTAGE]: null,
        upperLimit: null,
      };
